import { Device } from '@/utils/DeviceUtil';
import { shareApi } from '@/utils/ShareApi';
const copyExecCommand = (url) => {
    const textArea = document.createElement('textarea');
    textArea.value = url;
    // 建立假的 textarea
    document.body.appendChild(textArea);

    // 如果是 iOS 裝置
    if (Device.iOS()) {
        const range = document.createRange();
        range.selectNodeContents(textArea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, 999999);
    } else {
        textArea.select();
    }
    let copySuccess = true;
    try {
        document.execCommand('Copy');
    } catch (e) {
        copySuccess = false;
        console.log('Unable to copy to clipboard', e);
    }
    document.body.removeChild(textArea);
    return copySuccess;
};
export const shareLink = async(shareTo, articleSeq, articleId) => {
    let url = '';
    let copySuccess = false;
    if (articleSeq) {
        url = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_CONTEXT_PATH}/articlePage/${articleSeq}`;
    } else {
        url = window.location.href;
    }

    if (shareTo === 'FB') {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&u=${encodeURI(
                url
            )}&display=iframe&ref=plugin`
        );
    } else if (shareTo === 'LINE') {
        window.open(
            `https://line.me/R/msg/text/?${encodeURI(url)}`
        );
    } else if (shareTo === 'COPY') {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(url);
            copySuccess = true;
        } else {
            copySuccess = copyExecCommand(url);
        }
        // copySuccess = await navigator.clipboard
        //     .writeText(textArea.value)
        //     .then(() => {
        //         return true;
        //     })
        //     .catch(() => {});
    }
    shareApi({
        articleId: articleId || 'other',
        shareType: shareTo
    });
    return { copySuccess };
};
